export default __webpack_public_path__ + "static/media/language-heart.c24babe1.svg";